/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBrunchDiningIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-brunch-dining"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.2 20.15L15.85 20.15L15.85 21.48Q15.85 22.02 15.46 22.41Q15.07 22.8 14.53 22.8L2.52 22.8Q1.98 22.8 1.59 22.41Q1.2 22.02 1.2 21.48ZM1.2 18.15L1.2 16.82Q1.2 16.27 1.59 15.89Q1.98 15.5 2.52 15.5L6.38 15.5L6.38 14.82Q6.38 14.28 6.76 13.89Q7.15 13.5 7.7 13.5L9.32 13.5Q9.88 13.5 10.26 13.89Q10.65 14.28 10.65 14.82L10.65 15.5L14.53 15.5Q15.07 15.5 15.46 15.89Q15.85 16.27 15.85 16.82L15.85 18.15ZM17.85 16.63Q16.77 15.43 16.14 14.35Q15.5 13.28 15.5 11.57L15.5 2.52Q15.5 1.98 15.89 1.59Q16.27 1.2 16.82 1.2L21.48 1.2Q22.02 1.2 22.41 1.59Q22.8 1.98 22.8 2.52L22.8 11.57Q22.8 13.28 22.19 14.35Q21.57 15.43 20.5 16.63L20.5 20.15L21.48 20.15Q22.02 20.15 22.41 20.54Q22.8 20.93 22.8 21.48Q22.8 22.02 22.41 22.41Q22.02 22.8 21.48 22.8L19.18 22.8Q18.63 22.8 18.24 22.41Q17.85 22.02 17.85 21.48ZM18.15 7.6L20.15 7.6L20.15 3.85L18.15 3.85Z" fill={color} />
    </svg>
  );
}
